import styled, { css } from 'styled-components';
import { device, hexToRGB, typography } from '@/styles/helpers';
import { ScBanksLogosListWrapper } from '../../../../modules/promo/components/BanksLogosList/styled';
import { ScCopyCode } from '../../components/DashedCopyCode/styled';
import { ScLogo, type ScLogoProps } from '../../components/Logo/styled';
import { ScOfferCard } from '../../components/OfferCard/styled';
import { ScTopGames } from '../../components/TopGames/styled';
import { ScTermsAndConditions } from '../BenefitsTemplate/components/Terms&Conds/styled';

export type TBgColor = 'black' | 'blue';

interface IScBenefitsTemplateProps {
  bgImage: string;
  bgMobImg?: string;
  fixedRegButton?: boolean;
  isTop?: boolean;
  bgColor?: TBgColor;
  paymentsMarginTop?: number;
  fixedMobBg?: boolean;
  mobTopGames?: boolean;
  transparentBgMobLogo?: boolean;
  mainImgSize?: ScLogoProps;
  isMobLogoMarginBottom?: boolean;
  hideJackpot?: boolean;
  withoutMobPadding?: boolean;
  hidePaymentsOnMobile?: boolean;
  mobBgHeight?: number;
  hiddenMobRegBtnBg?: boolean;
  widthRegBtn?: number;
  fontSizeRegBtnDesk?: number;
  fontSizeRegBtnMob?: number;
  offerCard?: boolean;
}

export const ScBenefitsTemplate = styled.div<IScBenefitsTemplateProps>`
  display: flex;
  align-items: center;
  background: url(${({ bgImage }) => bgImage});
  background-color: ${({ bgColor, theme }) =>
    bgColor === 'blue' ? theme.violetBlue : theme.blackColor};
  background-position: top center;
  background-repeat: no-repeat;
  background-size: ${({ bgColor }) =>
    bgColor === 'blue' ? '100% 864px' : 'cover'};
  background-attachment: fixed;
  padding: 32px 16px 28px;
  position: relative;
  min-height: 100vh;
  min-height: 100dvh;
  flex-direction: column;
  justify-content: center;
  overflow: clip;
  @media (${device.mobile}) {
    padding-block: 16px;
    padding: 16px 16px 0;
    justify-content: flex-start;
    ${({ fixedRegButton }) =>
      fixedRegButton &&
      css`
        padding-bottom: 0;
      `}
    ${({ withoutMobPadding, fixedRegButton }) =>
      (withoutMobPadding || fixedRegButton) &&
      css`
        padding: 32px 0 0;
      `}
  }
  @media (max-width: 640px) {
    background-attachment: fixed;
    padding: 16px 16px 0;
    ${({ bgMobImg }) =>
      bgMobImg &&
      css`
        background-image: url(${bgMobImg});
      `}
    ${({ fixedMobBg, mobBgHeight }) =>
      fixedMobBg
        ? css`
            background-size: cover;
            background-position: center;
          `
        : css`
            background-size: 640px ${mobBgHeight ? `${mobBgHeight}px` : '100vh'};
          `}
  }

  .left-img {
    display: block;
    max-width: 100%;
  }

  .left-img {
    position: absolute;
    left: 0;
    top: 12%;
    max-width: 200px;
    @media (${device.mobile}) {
      display: none;
    }
  }

  & .container {
    width: min(1184px, 100%);
    padding: 0 16px;
    margin-inline: auto;
    margin: 0 auto;
    ${ScLogo} {
      margin: 0 auto;
    }

    @media (${device.mobile}) {
      padding: 0;
      ${({ isTop, transparentBgMobLogo }) =>
        isTop &&
        css`
          ${ScLogo} {
            position: fixed;
            top: 0px;
            left: 0;
            right: 0;
            height: 64px;
            z-index: 5;
            padding: 16px 0 16px;
            background: ${({ theme }) =>
              transparentBgMobLogo
                ? 'rgba(0, 0, 0, 0.10)'
                : theme.midnightBlue};
            transition: 0.3s;
            box-shadow: ${({ theme }) =>
              transparentBgMobLogo
                ? '0 0 0 100vmax rgba(0, 0, 0, 0.10)'
                : `0 0 0 100vmax ${theme.midnightBlue}`};
            backdrop-filter: ${transparentBgMobLogo ? 'blur(5.5px)' : 'none'};
            width: 100vw;
            overflow: hidden;
            clip-path: inset(0px -100vmax);
          }
        `}
    }
  }

  & .top-section {
    display: grid;
    grid-template-columns: 1fr 1fr;
    @media (${device.mobile}) {
      grid-template-columns: 1fr;
      margin-bottom: 16px;
      justify-content: center;
    }

    & .mob-img {
      display: none;
      @media (${device.mobile}) {
        display: block;
        margin-top: 16px;
        ${({ isMobLogoMarginBottom }) =>
          isMobLogoMarginBottom &&
          css`
            margin-bottom: -60px;
          `}
      }
      @media (min-width: 360px) and (max-width: 418px) {
        width: 100%;
      }
    }

    & .code-wrapper {
      height: 40px;
      margin-top: 32px;
      @media (${device.mobile}) {
        margin-top: 16px;
      }
      & p {
        padding-block: 4px;
        @media (${device.mobile}) {
          font-size: 20px;
        }
        @media (min-width: 360px) and (max-width: 372px) {
          font-size: 18px;
        }
      }

      & button {
        height: 40px;
      }
    }

    & .left-column {
      display: flex;
      flex-direction: column;
      align-items: center;
      @media (${device.mobile}) {
        margin-top: 8px;
        ${({ isTop, transparentBgMobLogo }) =>
          isTop &&
          css`
            ${ScLogo} {
              position: fixed;
              top: 0px;
              height: 64px;
              z-index: 5;
              padding: 16px;
              background: ${({ theme }) =>
                transparentBgMobLogo
                  ? 'rgba(0, 0, 0, 0.10)'
                  : theme.midnightBlue};
              transition: 0.3s;
              box-shadow: ${({ theme }) =>
                transparentBgMobLogo
                  ? '0 0 0 100vmax rgba(0, 0, 0, 0.10)'
                  : `0 0 0 100vmax ${theme.midnightBlue}`};
              backdrop-filter: ${transparentBgMobLogo ? 'blur(5.5px)' : 'none'};
              width: 100%;
              overflow: hidden;
              clip-path: inset(0px -100vmax);
            }
          `}
      }

      ${ScTermsAndConditions} {
        padding: 0;
        @media (${device.mobile}) {
          margin-top: 8px;
        }
      }

      ${ScOfferCard} {
        margin-top: 24px;
      }

      & .terms-content ol {
        text-align: justify;
      }

      ${ScCopyCode} {
        button {
          border-radius: ${({ offerCard }) => (offerCard ? '8px' : '12px')};
        }
      }

      .reg-button {
        margin: 32px 0 8px 0;
        width: 100%;
        max-width: 320px;
        border-radius: 12px;
        display: none;
        @media (${device.mobile}) {
          display: block;
          max-width: none;
          margin: 16px 0 8px 0;
        }
        .text {
          font-size: 20px;
          line-height: 24px;
          letter-spacing: 1%;
        }
      }

      .desktop-wrapper {
        height: 56px;
        width: ${({ widthRegBtn }) =>
          widthRegBtn ? `${widthRegBtn}px` : '348px'};
        margin-top: 32px;
        display: block;
        .text {
          font-size: ${({ fontSizeRegBtnDesk }) =>
            fontSizeRegBtnDesk ? `${fontSizeRegBtnDesk}px` : '22px'};
        }
        @media (${device.mobile}) {
          display: none;
        }
      }

      & .bonus {
        margin: 32px 0 0;
        color: #f0c018;
        text-transform: uppercase;
        font-weight: 700;
        text-align: center;
        position: relative;
        z-index: 2;
        @media (${device.mobile}) {
          margin: 0px;
        }

        & .title {
          font-size: 22px;
          line-height: 28px;
          letter-spacing: 0.44px;
          @media (${device.mobile}) {
            font-size: 20px;
            line-height: 26px;
          }
        }

        & .fs-count {
          font-size: 200px;
          line-height: 100%;
          letter-spacing: 6px;
          margin: -16px 0;
          @media (${device.mobile}) {
            font-size: 160px;
            line-height: 100%;
            letter-spacing: 3%;
          }
        }

        & .medium-count {
          font-size: 128px;
          letter-spacing: 3.84px;
          margin-block: -4px;
          @media (${device.mobile}) {
            font-size: 116px;
            letter-spacing: 3.48px;
          }
        }

        &:not(:has(> p.title)) .medium-count {
          font-size: 128px;
          line-height: 128px;
          letter-spacing: 3.84px;
          @media (${device.mobile}) {
            font-size: 64px;
            line-height: 64px;
            letter-spacing: 1.92px;
          }
        }

        & .fs {
          font-size: 40px;
          line-height: 100%;
          letter-spacing: 0.8px;
          @media (${device.mobile}) {
            font-size: 32px;
            line-height: 100%;
            letter-spacing: 2%;
          }
        }
      }
    }

    & .right-column {
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;
      @media (${device.mobile}) {
        margin-top: 16px;
      }

      .winners-wrapper {
        height: 276px;
        overflow: hidden;
        width: 576px;
        .subtitle {
          text-transform: uppercase;
          ${typography['headline2']};
          @media (${device.mobile}) {
            ${typography['headline2mobile']};
          }
        }
        @media (${device.mobile}) {
          width: 100%;
          height: 114px;
        }
        .winner-box.new-winners {
          display: flex;
          flex-direction: column;
          gap: 16px;
        }
        .subtitle {
          text-align: center;
        }
      }
      .main-img {
        @media (${device.mobile}) {
          display: none;
        }
      }
      & button {
        width: min(320px, 100%);
        @media (${device.mobile}) {
          width: 100%;
        }
      }
      ${({ mobTopGames }) =>
        mobTopGames &&
        css`
          ${ScTopGames} {
            margin-bottom: 40px;
          }
        `}
    }
  }

  & .bottom-section {
    display: grid;
    grid-template-columns: 1fr 1fr;
    @media (${device.mobile}) {
      grid-template-columns: 1fr;
    }

    & > .jackpot {
      display: flex;
      justify-content: center;
      align-items: center;
      flex-direction: column;
      gap: 16px;

      & > .title {
        color: ${({ theme }) => hexToRGB(theme.whiteColor, 0.6)};
        font-size: 22px;
        font-weight: 700;
        line-height: 28px;
        letter-spacing: 0.44px;
        text-transform: uppercase;
        @media (${device.mobile}) {
          font-size: 20px;
          line-height: 26px;
        }
      }

      & > .prize {
        font-size: 56px;
        font-weight: 700;
        line-height: 100%;
        letter-spacing: 1.68px;
        text-transform: uppercase;
        @media (${device.mobile}) {
          font-size: 48px;
          letter-spacing: 1.44px;
        }
      }
    }
  }
  .payments-wrapper {
    display: flex;
    width: 100%;
    justify-content: center;
    ${ScBanksLogosListWrapper} {
      display: flex;
      gap: 16px;
      justify-content: space-between;
      margin-top: ${({ paymentsMarginTop }) =>
        paymentsMarginTop ? `${paymentsMarginTop}px` : '48px'};
      width: 100%;
      max-width: 1248px;
      padding: 0 16px;
      @media (${device.mobile}) {
        gap: 12px;
        background: ${({ theme, bgColor }) =>
          bgColor === 'blue' ? theme.darkIndigo : theme.grayDarkColor};
        flex-wrap: wrap;
        margin-top: 16px;
        padding: 16px;
        border-radius: 12px;
        height: fit-content;
        ${({ withoutMobPadding }) =>
          withoutMobPadding &&
          css`
            margin: 0 16px;
          `}
      }
      @media (${device.mobileXS}) {
        justify-content: center;
        ${({ withoutMobPadding }) =>
          withoutMobPadding &&
          css`
            margin: 0 16px;
          `}
      }
    }
  }
  .bottom-top-games {
    margin-top: 64px;
    @media (${device.mobile}) {
      margin-top: 40px;
    }
  }

  .mobile-wrapper {
    display: none;
    position: ${({ hidePaymentsOnMobile }) =>
      hidePaymentsOnMobile ? 'fixed' : 'sticky'};
    left: 0;
    bottom: 0;
    z-index: 2;
    background: ${({ hiddenMobRegBtnBg }) => (hiddenMobRegBtnBg ? 'none' : '')}
      linear-gradient(0deg, #0a0b37 80.11%, rgba(10, 11, 55, 0) 100%);
    padding: 16px;
    width: 100vw;
    height: 88px;
    margin-top: 16px;

    .text {
      font-size: ${({ fontSizeRegBtnMob }) =>
        fontSizeRegBtnMob ? `${fontSizeRegBtnMob}px` : '24px'};
      line-height: 32px;
      letter-spacing: 0.24px;
      font-weight: 700;
    }

    @media (${device.mobile}) {
      display: block;
    }
  }
`;
